          <template>
  <b-modal id="modelSetting"
           ref = "modelSetting"
           size="lg"
           @show="show"
           :hide-footer="true"
           :hide-header="true"
           :no-close-on-backdrop="!states.userHasAddress">
    <span  @click="close()" class="close-icon">
      <icon name="close" />
    </span>

    <b-row>

      <b-col cols="3" class="setting-head">

        <div class="upload">
          <m-upload-img :img-src="states.userAvatar"></m-upload-img>
        </div>
        <p class="setting-head-title">Account Settings</p>
        <div @click="selectMenu('overView')"
             class="setting-menu"
             :class="{'setting-menu-active': selected === 'overView'}">
          Overview
        </div>
        <div @click="selectMenu('changePassword')"
             class="setting-menu"
             :class="{'setting-menu-active': selected === 'changePassword'}"
             v-if="states.userHasAddress">
          Change Password</div>
        <div @click="selectMenu('payments')"
             class="setting-menu"
             :class="{'setting-menu-active': selected === 'payments'}">
          Payment Info
        </div>
      </b-col>
      <b-col cols="9" class="bcol">
        <b-alert  :show="!states.userHasAddress && !states.initUserInfo">
          For the first time, Please fill your information
        </b-alert>
        <div v-if ="selected === 'overView'" >
          <b-row class="setting-item">
            <b-col sm="3"><label >First Name :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="states.userInfo.FirstName" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Last Name :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="states.userInfo.LastName" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Email :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="states.userInfo.Email" disabled></b-form-input>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Address* :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="userAddress.AddressLine"
                            :state ="userValid.address.state"></b-form-input>
              <span v-if="userValid.address.text" class="text-danger">{{userValid.address.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Company* :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="states.userInfo.Company"
                            :state ="userValid.company.state"></b-form-input>
              <span v-if="userValid.company.text" class="text-danger">{{userValid.company.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >City* :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="userAddress.CityName"
                            :state ="userValid.city.state"></b-form-input>
              <span v-if="userValid.city.text" class="text-danger">{{userValid.city.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >State* :</label ></b-col>
            <b-col sm="9">
              <b-form-select v-model="userAddress.StateCode"
                             :state ="userValid.state.state">
                <option v-for = "item in  $store.state.geo.states"
                        :value="item.code">
                  {{item.name}}
                </option>
              </b-form-select>
              <span v-if="userPaymentCardValid.State.text" class="text-danger">{{userPaymentCardValid.State.text}}</span>
              <span v-if="userValid.state.text" class="text-danger">{{userValid.state.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >ZIP Code* :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="userAddress.ZipCode"
                            :state ="userValid.zip.state"></b-form-input>
              <span v-if="userValid.zip.text" class="text-danger">{{userValid.zip.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Phone :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="text" size="sm" v-model="states.userInfo.HomePhone"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="setting-item" v-if="states.userHasAddress">
            <b-col sm="3"><label >Password* :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="password" size="sm" v-model="checkedPassword"
                            :state ="userValid.password.state"></b-form-input>
              <span v-if="userValid.password.text" class="text-danger">{{userValid.password.text}}<br></span>
              <span v-if="states.userHasAddress">Please enter your old password to confirm any changes</span>
            </b-col>
          </b-row>
          <b-row class="setting-item-notice">* Required</b-row>

          <b-row class="setting-btn justify-content-center">
            <b-btn @click="checkPasswordBeforeSave()" :disabled="saveDisabled">Save Profile Settings</b-btn>
          </b-row>
        </div>
        <div v-if = "selected === 'changePassword'">
          <b-row class="setting-item">
            <b-col sm="3"><label >New Password :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="password" size="sm" v-model="newPassword"
                            :state ="passwordValid.newPassword.state"></b-form-input>
              <span v-if="passwordValid.newPassword.text" class="text-danger">{{passwordValid.newPassword.text}}</span>
              <span v-if="newPassword === ''">More than 8 characters, at least one number, at least one uppercase letter</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Re-enter New Password :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="password" size="sm" v-model="reNewPassword"
                            :state ="passwordValid.reNewPassword.state"></b-form-input>
              <span v-if="passwordValid.reNewPassword.text" class="text-danger">{{passwordValid.reNewPassword.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="3"><label >Old Password :</label ></b-col>
            <b-col sm="9">
              <b-form-input type="password" size="sm" v-model="oldPassword"
                            :state ="passwordValid.oldPassword.state" ></b-form-input>
              <span>Please enter your current password to confirm any changes</span>
              <span v-if="passwordValid.oldPassword.text" class="text-danger">{{passwordValid.oldPassword.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-btn justify-content-center">
            <b-btn @click="savePassword()" :disabled="saveDisabled">Save Profile Settings</b-btn>
          </b-row>
        </div>
        <div v-if ="selected === 'payments'" >
          <h3>Save a Credit Card</h3>
          <p>Expedite the checkout process by securely saving your card here.</p>
          <b-row class="setting-item">
            <b-col sm="4">Card Holder Name: </b-col>
            <b-col>
              <b-form-input type="text"
                            v-model="userPaymantCard.HolderName"
                            :state="userPaymentCardValid.HolderName.state"></b-form-input>
              <span v-if="userPaymentCardValid.HolderName.text" class="text-danger">{{userPaymentCardValid.HolderName.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >Credit Card Number :</label ></b-col>
            <b-col>
              <b-form-input type="text"
                            v-model="userPaymantCard.CardNumber"
                            :state="userPaymentCardValid.CardNumber.state"></b-form-input>
              <span v-if="userPaymentCardValid.CardNumber.text" class="text-danger">{{userPaymentCardValid.CardNumber.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >Card Type :</label ></b-col>
            <b-col>
              <b-form-select v-model="userPaymantCard.CardType">
                <option value="10" selected="true">VISA</option>
                <option value="20">MasterCard</option>
                <option value="30">American Express</option>
                <option value="40">Discover</option>
              </b-form-select>
            </b-col>
            <b-col sm="1" style="display: flex; align-items: center">
              CVV
            </b-col>
            <b-col>
              <b-form-input v-model="userPaymantCard.CVV"
                            :state="userPaymentCardValid.CVV.state"/></b-col>
            <span v-if="userPaymentCardValid.CVV.text" class="text-danger">{{userPaymentCardValid.CVV.text}}</span>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >Expiration :</label ></b-col>
            <b-col>
              <b-form-select v-model="userPaymantCard.ExpirationMonth" :options="expiredMonth"  />
              <span v-if="userPaymentCardValid.ExpirationMonth.text" class="text-danger">
                {{userPaymentCardValid.ExpirationMonth.text}}</span>

              <!--<b-form-input type="text" size="sm"-->
                            <!--v-model="userPaymantCard.ExpirationMonth"-->
                            <!--:state ="userPaymentCardValid.ExpirationMonth.state"></b-form-input>-->
            </b-col>
            <b-col>
              <b-form-select v-model="userPaymantCard.ExpirationYear"
                             :state ="userPaymentCardValid.ExpirationYear.state"
                             :options="expiredYear"  />
              <span v-if="userPaymentCardValid.ExpirationYear.text" class="text-danger">
                {{userPaymentCardValid.ExpirationYear.text}}</span>

              <!--<b-form-input v-model="userPaymantCard.ExpirationYear"-->
                            <!--:state ="userPaymentCardValid.ExpirationYear.state"></b-form-input>-->
              <!--<span v-if="userPaymentCardValid.ExpirationYear.text" class="text-danger">{{userPaymentCardValid.ExpirationYear.text}}</span>-->
            </b-col>
          </b-row>
          <b-row>
            <b-col>&nbsp;</b-col>
          </b-row>
          <b-row>
            <b-col>
              <h3>Billling Information</h3>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >Address :</label ></b-col>
            <b-col>
              <b-form-input type="text" size="sm"
                            v-model="userPaymantCard.Address"
                            :state ="userPaymentCardValid.Address.state"></b-form-input>
              <span v-if="userPaymentCardValid.Address.text" class="text-danger">{{userPaymentCardValid.Address.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >City :</label ></b-col>
            <b-col>
              <b-form-input type="text" size="sm"
                            v-model="userPaymantCard.City"
                            :state ="userPaymentCardValid.City.state"></b-form-input>
              <span v-if="userPaymentCardValid.City.text" class="text-danger">{{userPaymentCardValid.City.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >State :</label ></b-col>
            <b-col>
              <b-form-select v-model="userPaymantCard.State"
                             :state ="userPaymentCardValid.State.state">
                <option v-for = "item in  $store.state.geo.states"
                        :value="item.code">
                  {{item.name}}
                </option>
              </b-form-select>
              <span v-if="userPaymentCardValid.State.text" class="text-danger">{{userPaymentCardValid.State.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >ZIP Code :</label ></b-col>
            <b-col>
              <b-form-input type="text" size="sm"
                            v-model="userPaymantCard.ZipCode"
                            :state ="userPaymentCardValid.ZipCode.state"></b-form-input>
              <span v-if="userPaymentCardValid.ZipCode.text" class="text-danger">{{userPaymentCardValid.ZipCode.text}}</span>
            </b-col>
          </b-row>
          <b-row class="setting-item">
            <b-col sm="4"><label >Company Name(optional) :</label ></b-col>
            <b-col>
              <b-form-input type="text" size="sm" v-model="userPaymantCard.CompanyName"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-alert :show="alertDesc!==''" variant="success"  class="the-box">{{alertDesc}}</b-alert>
            </b-col>
          </b-row>
          <b-row class="setting-btn justify-content-center">
            <b-btn @click="saveUserPaymentCard" :disabled="saveDisabled">Save</b-btn>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
  import MUploadImg from '@/components/landings/MUploadImg'
  import notification from '@/components/common/notification'

  export default {
    components: {
      MUploadImg
    },
    data () {
      return {
        states: this.$store.state.user,
        selected: 'overView',
        payment: {},
        oldPassword: '',
        newPassword: '',
        reNewPassword: '',
        checkedPassword: '',
        alertDesc: '',
        saveDisabled: false,
        passwordValid: {
          oldPassword: {
            state: null,
            text: ''
          },
          newPassword: {
            state: null,
            text: ''
          },
          reNewPassword: {
            state: null,
            text: ''
          }
        },
        userValid: {
          address: {
            state: null,
            text: ''
          },
          company: {
            state: null,
            text: ''
          },
          city: {
            state: null,
            text: ''
          },
          state: {
            state: null,
            text: ''
          },
          zip: {
            state: null,
            text: ''
          },
          password: {
            state: null,
            text: ''
          }
        },
        userPaymentCardValid: {
          HolderName: {
            state: null,
            text: ''
          },
          CardNumber: {
            state: null,
            text: ''
          },
          CardType: {
            state: null,
            text: ''
          },
          CVV: {
            state: null,
            text: ''
          },
          ExpirationMonth: {
            state: null,
            text: ''
          },
          ExpirationYear: {
            state: null,
            text: ''
          },
          Address: {
            state: null,
            text: ''
          },
          City: {
            state: null,
            text: ''
          },
          State: {
            state: null,
            text: ''
          },
          ZipCode: {
            state: null,
            text: ''
          },
          CompanyName: {
            state: null,
            text: ''
          }
        }
      }
    },
    computed: {
      userAddress () {
        return this.$store.state.user.userAddress
      },
      userPaymantCard () {
        return this.$store.state.user.userPaymentCard
      },
      expiredYear () {
        let result = []
        let now = new Date()
        let year = now.getFullYear()
        for (let i = 0; i <= 6; i++) {
          result.push(year + i)
        }
        return result
      },
      expiredMonth () {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      }
    },
    methods: {
      show () {
        // this.$store.dispatch('user/getEditUserInfo')
        this.$store.dispatch('user/getUserPaymentCard')
        if (this.$store.state.site.UserImg) {
          this.states.userAvatar = this.$store.state.site.UserImg
        }
      },
      selectMenu (val) {
        this.selected = val
      },
      close () {
        this.$refs.modelSetting.hide()
      },
      validSetting () {
        let isValid = true
        if (!this.userAddress.AddressLine) {
          this.userValid.address.state = false
          this.userValid.address.text = "It's required"
          isValid = false
        }
        if (!this.states.userInfo.Company) {
          this.userValid.company.state = false
          this.userValid.company.text = "It's required"
          isValid = false
        }
        if (!this.userAddress.CityName) {
          this.userValid.city.state = false
          this.userValid.city.text = "It's required"
          isValid = false
        }
        if (!this.userAddress.StateCode) {
          this.userValid.state.state = false
          this.userValid.state.text = "It's required"
          isValid = false
        }
        if (!this.userAddress.ZipCode && this.userAddress.ZipCode.lenght !== 5) {
          this.userValid.zip.state = false
          this.userValid.zip.text = "It's required"
          isValid = false
        }
        if (!this.checkedPassword) {
          this.userValid.password.state = false
          this.userValid.password.text = "It's required"
          isValid = false
        }

        return isValid
      },
      validPaymentCard () {
        let isValid = true
        if (!this.userPaymantCard.HolderName) {
          this.userPaymentCardValid.HolderName.state = false
          this.userPaymentCardValid.HolderName.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.CardNumber) {
          this.userPaymentCardValid.CardNumber.state = false
          this.userPaymentCardValid.CardNumber.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.CVV) {
          this.userPaymentCardValid.CVV.state = false
          this.userPaymentCardValid.CVV.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.State) {
          this.userPaymentCardValid.State.state = false
          this.userPaymentCardValid.State.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.ZipCode && this.userAddress.ZipCode.lenght !== 5) {
          this.userPaymentCardValid.ZipCode.state = false
          this.userPaymentCardValid.ZipCode.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.ExpirationYear) {
          this.userPaymentCardValid.ExpirationYear.state = false
          this.userPaymentCardValid.ExpirationYear.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.ExpirationMonth) {
          this.userPaymentCardValid.ExpirationMonth.state = false
          this.userPaymentCardValid.ExpirationMonth.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.City) {
          this.userPaymentCardValid.City.state = false
          this.userPaymentCardValid.City.text = "It's required"
          isValid = false
        }
        if (!this.userPaymantCard.Address) {
          this.userPaymentCardValid.Address.state = false
          this.userPaymentCardValid.Address.text = "It's required"
          isValid = false
        }
        return isValid
      },
      saveUserPaymentCard () {
        this.clearValid(this.userPaymentCardValid)
        if (!this.validPaymentCard()) {
          return false
        }
        this.alertDesc = ''
        this.saveDisabled = true
        this.$http.post('PlaceOrder.aspx/InsertOrUpdateUserPaymentCards', {
          cards: this.states.userPaymentCard
        }).then(resp => {
          if (resp.body.d.ResultFlag) {
            this.saveDisabled = false
            notification.notice('success', 'Save payment information successfully')
          }
        }, resp => {
          notification.notice('error', 'Failed to save payment information , please try again')
          this.alertDesc = ''
          this.saveDisabled = false
        })
      },
      parseDate (item) {
      },
      saveSetting () {
        this.saveDisabled = true
        this.$http.post('ba/EditProfile.aspx/UpdateUser', {
          user: this.states.userInfo,
          userGuid: this.states.userInfo.UserGuid
        }).then(resp => {
          this.saveDisabled = false
          this.checkedPassword = ''
          notification.notice('success', 'Save user information successfully')
          if (!this.states.userHasAddress) {
            this.states.userHasAddress = true
          }
        }, resp => {
          this.saveDisabled = false
          notification.notice('error', 'Failed to save user information , please try again')
        })
      },
      checkPasswordBeforeSave: function () {
        this.clearValid(this.userValid)
        if (!this.validSetting()) {
          return false
        }
        this.saveDisabled = true
        this.$http.post('ba/EditProfile.aspx/CheckPassword', {
          'oldPwd': this.checkedPassword
        }).then(resp => {
          this.saveSetting()
        }, resp => {
          this.saveDisabled = false
          this.userValid.password.state = false
          this.userValid.password.text = 'Wrong password.'
        })
      },
      savePassword () {
        this.clearValid(this.passwordValid)
        let isValid = true
        this.passwordValid.newPassword.text = ''

        if (this.newPassword.length < 10) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text = 'least 8  characters; '
          isValid = false
        }
        if (!(/\d/gi.test(this.newPassword))) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text += 'at least one number; '
          isValid = false
        }
        if (!(/(?=.*[A-Z])/.test(this.newPassword))) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text += 'at least one uppercase letter; '
          isValid = false
        }
        if (!(/(?=.*[a-z])/.test(this.newPassword))) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text += 'at least one lowercase letter; '
          isValid = false
        }
        if (this.newPassword !== this.reNewPassword) {
          this.passwordValid.reNewPassword.state = false
          this.passwordValid.reNewPassword.text = 'The new passwords you\'ve entered do not match. Please re-enter.'
          isValid = false
        }
        if (!this.oldPassword) {
          this.passwordValid.oldPassword.state = false
          this.passwordValid.oldPassword.text = 'Please enter passwords'
          isValid = false
        }
        if (!isValid) {
          return false
        }
        this.saveDisabled = true

        this.$http.post('ba/EditProfile.aspx/CheckPassword', {
          oldPwd: this.oldPassword
        }).then(resp => {
          this.saveDisabled = false
          this.savePasswordSubmit()
        }, resp => {
          this.saveDisabled = false
          this.passwordValid.oldPassword.state = false
          this.passwordValid.oldPassword.text = 'The old password is invalid.'
        })
      },
      savePasswordSubmit () {
        this.$http.post('ba/EditProfile.aspx/UpdatePassword', {
          newPwd: this.newPassword,
          userGuid: this.states.userInfo.UserGuid
        }).then(resp => {
          this.saveDisabled = false
          if (resp.body.d.DataSource) {
            this.newPassword = ''
            this.oldPassword = ''
            this.reNewPassword = ''
            notification.notice('success', 'Update password successfully')
          } else {
            notification.notice('error', 'Failed to save update password, please try again')
          }
        }, resp => {
          this.saveDisabled = false
          notification.notice('error', 'Failed to save update password, please try again')
        })
      },
      clearValid (items) {
        for (let key in items) {
          items[key].state = null
          items[key].text = false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .setting-head{
    background-color: $color-primary-light;
    //padding-top: 40px;
    padding-left: 20px !important;
  }

  .setting-menu {
    cursor: pointer;
    padding: 5px 0;
  }
  .setting-menu:hover {
    color: $color-text-grey;
    font-weight: bold;
  }
  .upload{
    text-align: center;margin-top: 20px
  }
  .setting-head-title{
    padding-top: 20px;
    font-size: 20px;
  }
  .setting-item-notice{
    padding-left: 5px;
  }
  .setting-item{
    padding: 10px 20px 10px 0
  }
  .setting-btn{
    padding-top: 30px;
    padding-bottom: 40px;
  }
  .close-icon{
    font-size: 24px;
    font-weight: bold;
    position: absolute;
    top: 0;
    right: 16px;
    background: #FFF;
    cursor: pointer;
    z-index: 100000;
  }
  .button {
    border-radius: 20px;
    border: 1px solid $color-primary;
    color: $color-primary;
    background: #FFF;
    padding-top: 7px;
    padding-bottom: 7px;
    width: 150px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    cursor: hand;
    clear: both;
  }
  .button:hover {
    background: $color-primary;
    color: $color-white;
  }
  .bcol{
    padding-right: 50px;
    padding-left: 40px;
    padding-top: 40px
  }
  .setting-menu-active {
    color: $color-primary;
    font-weight: bold;
  }
  .setting-menu-active:hover {
    color: $color-primary;
  }
</style>
<style>
  #modelSetting___BV_modal_body_{
    padding: 0 !important;
  }
</style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     



// WEBPACK FOOTER //
// src/components/landings/MModalSetting.vue